module.exports = __webpack_public_path__ + "static/img/geotap-game-lucre-games-tranquil-mode-mobile.873f4eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/geotap-game/geotap-game-lucre-games-tranquil-mode-mobile.jpg
// module id = k5zq
// module chunks = 0